import { T } from "@supersig/validate";
/**
 * The cursor types used by tldraw's default localization provider.
 *
 * @public */ export const TL_CURSOR_TYPES = new Set([
    "none",
    "default",
    "pointer",
    "cross",
    "grab",
    "rotate",
    "grabbing",
    "resize-edge",
    "resize-corner",
    "text",
    "move",
    "ew-resize",
    "ns-resize",
    "nesw-resize",
    "nwse-resize",
    "nesw-rotate",
    "nwse-rotate",
    "swne-rotate",
    "senw-rotate",
    "zoom-in",
    "zoom-out"
]);
/** @internal */ export const cursorTypeValidator = T.setEnum(TL_CURSOR_TYPES);
/** @internal */ export const cursorValidator = T.object({
    type: cursorTypeValidator,
    rotation: T.number
});
